<template>
  <div class="flex position-relative" v-click-outside="closeSearch">
    <div
      class="search-full-container w-full h-full absolute left-0 top-0"
      :class="{ flex: showFullSearch }"
      v-if="showFullSearch"
    >
      <!-- Textarea for order code input -->
      <textarea
        ref="navbarSearch"
        class="w-full input-search"
        placeholder="ادخل الأكواد للبحث عن طرودك (مفصولة بمسافة أو سطر جديد)"
        v-model="searchQuery"
        @keyup.esc="showFullSearch = false"
        @keyup.enter.exact="searchCode()"
        rows="3"
      ></textarea>

      <!-- Close icon -->
      <div class="absolute right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="resetTheQuerySearch()"
        />
      </div>
    </div>

    <!-- Search icon -->
    <vx-tooltip text="البحث" position="bottom" delay=".2s">
      <feather-icon
        svgClasses="'h-6 w-6"
        class="p-2 cursor-pointer"
        icon="SearchIcon"
        @click="showSearch()"
      />
    </vx-tooltip>
  </div>
</template>

<script>
import gTag from "@/mixins/gtag.js";

export default {
  mixins: [gTag],

  data() {
    return {
      showFullSearch: false,
      searchQuery: "",
    };
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  methods: {
    closeSearch() {
      this.showFullSearch = false;
    },
    resetTheQuerySearch() {
      this.searchQuery = "";
      this.showFullSearch = false;
    },
    showSearch() {
      this.showFullSearch = true;
      setTimeout(() => {
        this.$refs.navbarSearch.focus();
      }, 10);
    },
    async searchCode() {
      
      const codes = this.searchQuery.split(/[\s\n]+/).filter((code) => code.trim() !== "").join(",");
      
        if (codes.length > 0) {
          this.resetTheQuerySearch()
            this.$router.push({
              name: "Order-Search",
              query: {
                codes: codes
              }
            }).catch(() => {
            });
      } else {
        this.resetTheQuerySearch();
      }
    },
  },
};
</script>

<style scoped>
.input-search {
  border: none;
  padding: 0 40px;
  color: #6e6b7b;
  font-family: 'cairo';
  font-size: 16px;
  letter-spacing: 1px;
}

.input-search::placeholder {
  font-family: 'cairo';
  font-size: 16px;
  letter-spacing: 1px;
}

.dropdown-order-list {
  position: absolute;
  top: 50px;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.order-card {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.order-info {
  font-family: 'cairo';
  font-size: 14px;
  color: #6e6b7b;
}

.order-link:hover .order-info {
  background-color: #f1f1f1;
}
</style>
